import { render, staticRenderFns } from "./SubstationTotalPieChart.vue?vue&type=template&id=5162eae2&"
import script from "./SubstationTotalPieChart.vue?vue&type=script&lang=js&"
export * from "./SubstationTotalPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports